"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Source = void 0;
var eva_js_1 = require("@eva/eva.js");
var plugin_renderer_img_1 = require("@eva/plugin-renderer-img"); // 引入渲染图片所需要的组件和系统
var plugin_renderer_text_1 = require("@eva/plugin-renderer-text");
var plugin_transition_1 = require("@eva/plugin-transition");
var plugin_renderer_sprite_animation_1 = require("@eva/plugin-renderer-sprite-animation");
var render_1 = __importDefault(require("../render"));
var plugin_renderer_event_1 = require("@eva/plugin-renderer-event");
var controller_1 = __importDefault(require("../controller"));
var trackerPoint_1 = require("../trackerPoint");
var fish_1 = require("../feeder/fish");
var dialogBox_1 = __importDefault(require("../dialogBox"));
var utils_1 = require("../../util/utils");
// 资源
exports.Source = [{
        name: 'stand',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/V1_Stand/stand.png'
            },
            json: {
                type: 'json',
                url: './resource3d/V1_Stand/stand.json'
            }
        },
        preload: true
    },
    {
        name: 'look',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/V2_Look/Look.png'
            },
            json: {
                type: 'json',
                url: './resource3d/V2_Look/Look.json'
            }
        },
        preload: true
    }, {
        name: 'walk',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/V3_Walk/Walk.png'
            },
            json: {
                type: 'json',
                url: './resource3d/V3_Walk/Walk.json'
            }
        },
        preload: true
    }, {
        name: 'sit2',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/v5_Sit/Sit_Loop.png'
            },
            json: {
                type: 'json',
                url: './resource3d/v5_Sit/Sit_Loop.json'
            }
        },
        preload: true
    }, {
        name: 'taste',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/taste/taste.png'
            },
            json: {
                type: 'json',
                url: './resource3d/taste/taste.json'
            }
        },
        preload: true
    }, {
        name: 'eat',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/eat/eat.png'
            },
            json: {
                type: 'json',
                url: './resource3d/eat/eat.json'
            }
        },
        preload: true
    }, {
        name: 'reset',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/reset/reset.png'
            },
            json: {
                type: 'json',
                url: './resource3d/reset/reset.json'
            }
        },
        preload: true
    }, {
        name: 'hello',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/V7_hellow/cat_hello.png'
            },
            json: {
                type: 'json',
                url: './resource3d/V7_hellow/cat_hello.json'
            }
        },
        preload: true
    }, {
        name: 'loop',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/V8_cat_loop/cat_Loop.png'
            },
            json: {
                type: 'json',
                url: './resource3d/V8_cat_loop/cat_Loop.json'
            }
        },
        preload: true
    }, {
        name: 'back_up',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/Back/walk_Stand_Up.png'
            },
            json: {
                type: 'json',
                url: './resource3d/Back/walk_Stand_Up.json'
            }
        },
        preload: true
    }, {
        name: 'turn_back',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/Back/Turn_Back.png'
            },
            json: {
                type: 'json',
                url: './resource3d/Back/Turn_Back.json'
            }
        },
        preload: true
    }, {
        name: 'back_wallk',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/Back/back_wallk.png'
            },
            json: {
                type: 'json',
                url: './resource3d/Back/back_wallk.json'
            }
        },
        preload: true
    }];
// width =474;
// height = 298;
// x: -28,
//y: 68
var CatInstance = /** @class */ (function () {
    function CatInstance() {
        // @ts-ignore
        this.width = 310;
        this.height = 208;
        this.playActions = ['sit2', 'eat', 'taste', 'reset'];
        this.playIndex = 0;
        this.first = false;
        this.action = '';
        this.totalFrames = 0;
        this.resetTimes = 0;
        this.endAnimation = function () {
        };
        this.ignoreAction = ['walk', 'back'];
        this.firstPalyTag = false;
        this.firstSwitch = false;
        this.signPlayHello = false;
        this._mounted = false;
        this.regristCallback = null;
        this.catActionFun = null;
        this.catIndex = null;
        this.hideDialogBoxReturn = false;
        this.backActions = ['back_wallk', "turn_back", "back_up"];
        this.initResource();
        this.initGame();
    }
    CatInstance.prototype.initResource = function () {
        render_1.default.addResource(exports.Source).addSystem([new plugin_renderer_text_1.TextSystem(), new plugin_transition_1.TransitionSystem(), new plugin_renderer_sprite_animation_1.SpriteAnimationSystem(), new plugin_renderer_img_1.ImgSystem(), new plugin_renderer_event_1.EventSystem()]);
    };
    CatInstance.prototype.initGame = function () {
        this.cat = new eva_js_1.GameObject('cat1', {
            size: { width: this.width, height: this.height },
            origin: { x: 0, y: 0 },
            position: {
                x: 91,
                y: 135
            },
            anchor: {
                x: 0,
                y: 0
            },
            scale: {
                x: 0.8,
                y: 0.8
            }
        });
    };
    CatInstance.prototype.waitCallBackResult = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this._mounted) {
                resolve(true);
            }
            _this.regristCallback = resolve;
        });
    };
    CatInstance.prototype.setAnimationDuration = function () {
        var currentTime = new Date().getTime();
        return currentTime - this.playTime;
    };
    //是否是默认动画
    CatInstance.prototype.defaultAnimation = function () {
        var action = this.catSpriteAnimation.resource;
        return (['loop', 'stand', 'hello'].includes(action));
    };
    //
    CatInstance.prototype.switchGame = function (name, speed) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                //判断是否还有鱼干没有播放完
                //解决问题：猫咪返回的时候点击了金币，但是back 不能中途返回去吃鱼干，播放完back 然后查询状态自动去吃小鱼干
                if (['loop', 'stand', 'hello'].includes(name) && fish_1.Fish.eatFishStartOver) {
                    this.eatFishAction(true);
                    fish_1.Fish.eatFishStartOver = false;
                    return [2 /*return*/];
                }
                //改变金币的层级
                if (['loop', 'stand', 'hello'].includes(name)) {
                    //允许弹窗弹出
                    controller_1.default.applayPopup(true);
                    //允许这个动作下弹出
                    this.catActionFun && this.catActionFun(true);
                    controller_1.default.getPlaceCoin(55);
                }
                else {
                    controller_1.default.getPlaceCoin(1);
                }
                if (name === 'eat') {
                    fish_1.Fish.emptyFish();
                }
                if (this.firstSwitch) {
                    trackerPoint_1.POINT.imp({
                        tgt_event_id: 'h5_ACT_privilege_catdh',
                        tgt_name: 'h5-ACT-成长权益-权益猫动画',
                        param2: this.catSpriteAnimation.resource,
                        param3: new Date().getTime() - this.playTime
                    });
                }
                this.playTime = new Date().getTime();
                this.firstSwitch = true;
                // 创建 game object
                if (!this.first) {
                    this.catSpriteAnimation = this.cat.addComponent(
                    // @ts-ignore
                    new plugin_renderer_sprite_animation_1.SpriteAnimation({
                        autoPlay: false,
                        resource: name,
                        speed: speed || 180
                    }));
                    this.cat.addComponent(new plugin_renderer_event_1.Event()).on('tap', function (event) {
                        event.stopPropagation();
                        //隐藏对话框
                        _this.catClickHideDialogBox();
                        if (_this.catSpriteAnimation.resource === 'loop' || _this.catSpriteAnimation.resource === 'stand') {
                            _this.signPlayHello = true;
                        }
                        else {
                            //回调猫的点击
                            controller_1.default.catClickControl();
                        }
                        trackerPoint_1.POINT.click({
                            tgt_event_id: 'h5_ACT_privilege_catdh',
                            tgt_name: 'h5-ACT-成长权益-权益猫动画',
                            param2: _this.catSpriteAnimation.resource
                        });
                        var action = _this.catSpriteAnimation.resource;
                        if (action === 'loop' || action === 'hello' || action === 'stand') {
                            controller_1.default.handleEventTab && controller_1.default.handleEventTab('click_cat');
                        }
                    });
                }
                else {
                    this.switchSpeed(name);
                    this.catSpriteAnimation.resource = name;
                }
                this.first = true;
                return [2 /*return*/];
            });
        });
    };
    //修改速度
    CatInstance.prototype.switchSpeed = function (name) {
        var speed = 40;
        if (name === 'loop') {
            speed = 180;
        }
        else if (name === 'hello') {
            speed = 120;
            // 'back_wallk',"turn_back","back_up"
        }
        else if (name == 'back_wallk') {
            speed = 80;
        }
        else if (name === 'turn_back') {
            speed = 70;
        }
        else if (name === 'back_up') {
            speed = 40;
        }
        this.catSpriteAnimation.speed = speed;
    };
    CatInstance.prototype.play = function (name) {
        this.switchGame(name);
        render_1.default.renderGame(this.cat, 15);
        return Promise.resolve(true);
    };
    CatInstance.prototype.load = function (name, callBack, speed) {
        this.addChild(dialogBox_1.default.load());
        this.switchGame(name, speed);
        this.callBackEndAnimation = callBack;
        this.catIndex = render_1.default.renderGame(this.cat, 15);
        this.controllerAnimationFrame();
        this._mounted = true;
        this.regristCallback && this.regristCallback(true);
        setTimeout(function () {
            controller_1.default.handleEventTab && controller_1.default.handleEventTab('page_loading');
        }, 1000);
        return Promise.resolve(true);
    };
    CatInstance.prototype.awaitCatAction = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var action = _this.catSpriteAnimation.resource;
            _this.catActionFun = resolve;
            if (action !== 'loop' && action !== 'hello' && action !== 'stand') {
            }
            else {
                resolve(true);
            }
        });
    };
    //唤起对话框
    CatInstance.prototype.speak = function (sayTextList, scene) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _i, i, say, CloseModel;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: 
                    // 猫只有在loop和hello情况下展示对话框
                    return [4 /*yield*/, this.awaitCatAction()];
                    case 1:
                        // 猫只有在loop和hello情况下展示对话框
                        _c.sent();
                        //猫咪可见的情况下
                        return [4 /*yield*/, this.waitCallBackResult()];
                    case 2:
                        //猫咪可见的情况下
                        _c.sent();
                        if (!sayTextList.length) {
                            this.catIndex.zIndex = 15;
                            return [2 /*return*/];
                        }
                        trackerPoint_1.POINT.imp({
                            tgt_event_id: 'h5_ACT_privilege_catdh',
                            tgt_name: 'h5-ACT-成长权益-权益猫动画',
                            param2: controller_1.default.opportunityMap[scene],
                            param3: sayTextList.reduce(function (total, current) { return total + current + '/'; }, '')
                        });
                        _a = [];
                        for (_b in sayTextList)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 3;
                    case 3:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        i = _a[_i];
                        if (this.hideDialogBoxReturn) {
                            return [2 /*return*/];
                        }
                        say = sayTextList[i];
                        if (!say) {
                            return [3 /*break*/, 5];
                        }
                        this.showDialogBox();
                        dialogBox_1.default.model.transform.scale = { x: 1, y: 1 };
                        //修改对话框内容
                        dialogBox_1.default.setText(say.content);
                        //等待打开时间
                        return [4 /*yield*/, (0, utils_1.sleep)(3000)];
                    case 4:
                        //等待打开时间
                        _c.sent();
                        //消息已经曝光过
                        controller_1.default.handleEventTab && controller_1.default.handleEventTab(scene, say.id, 'gameOver');
                        if (sayTextList.length === (Number(i) + 1)) {
                            CloseModel = controller_1.default.applayPopup(true);
                            if (!CloseModel) {
                                this.hideDialogBox();
                            }
                        }
                        _c.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    //猫点击隐藏对话框
    CatInstance.prototype.catClickHideDialogBox = function () {
        var _this = this;
        if (dialogBox_1.default.model.transform.scale.x === 0) {
            return;
        }
        this.hideDialogBox();
        this.hideDialogBoxReturn = true;
        setTimeout(function () {
            _this.hideDialogBoxReturn = false;
        }, 3000);
    };
    //隐藏对话框
    CatInstance.prototype.hideDialogBox = function () {
        dialogBox_1.default.model.transform.scale = { x: 0, y: 0 };
        this.catIndex.zIndex = 15;
    };
    //展示对话框
    CatInstance.prototype.showDialogBox = function () {
        dialogBox_1.default.model.transform.scale = { x: 1, y: 1 };
        this.catIndex.zIndex = 205;
    };
    /**
     *
     * @param direct   无视条件直接播放走路去吃小鱼
     */
    // 吃鱼的动作
    CatInstance.prototype.eatFishAction = function (direct) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (direct || this.catSpriteAnimation.resource === 'stand' || this.catSpriteAnimation.resource === 'loop') {
                    this.action = 'walk';
                    this.catSpriteAnimation && this.catSpriteAnimation.stop();
                    this.frames = 0;
                    this.playIndex = 0;
                    this.catSpriteAnimation.play(1);
                    this.switchGame('walk');
                    this.totalFrames = 24;
                }
                return [2 /*return*/];
            });
        });
    };
    //小鱼掉落完后吃鱼
    CatInstance.prototype.fishFallOverStartEat = function (callback) {
        var action = this.catSpriteAnimation.resource;
        //判断猫咪当前动作
        if (__spreadArray(['walk', 'stand', 'loop', 'hello', 'back'], this.backActions, true).includes(action)) {
            return;
        }
        //注册回调
        this.catEatCallBack = callback;
        //播放吃鱼的同时，让鱼清空动画
        this.switchAnimation('eat', 2);
        // 让鱼清空动画
        return true;
    };
    //控制动画播放帧数,到多少帧停止
    CatInstance.prototype.controllerAnimationFrame = function () {
        // 监听帧数
        this.animationFrameChange();
        // 监听循环
        this.animationPlayLoop();
        //监听结束
        this.animationComplete();
    };
    //播放帧的监听
    CatInstance.prototype.animationFrameChange = function () {
        var _this = this;
        this.catSpriteAnimation.on('frameChange', function () {
            // console.log(this.catSpriteAnimation,'catSpriteAnimation')
            var action = _this.catSpriteAnimation.resource;
            if (!_this.firstPalyTag) {
                _this.firstPalyTag = true;
                trackerPoint_1.POINT.imp({
                    tgt_event_id: 'h5_ACT_privilege_catdh_ymjzsj',
                    tgt_name: 'h5-ACT-成长权益-权益猫动画-页面加载时间',
                    param2: new Date().getTime() - controller_1.default.timeStart,
                    param3: action
                });
            }
            //设置结束的帧数
            if (action === 'walk' || _this.backActions.includes(action)) {
                _this.frameListener();
                if (_this.frames >= _this.totalFrames) {
                    _this.endAnimation && _this.endAnimation(action);
                    _this.callBackEndAnimation && _this.callBackEndAnimation(action);
                    if (action === 'walk') {
                        _this.switchAnimation('sit2', Infinity);
                    }
                    // else if (action === 'back') {
                    //     this.switchAnimation('stand', Infinity);
                    // }
                    else if (action === 'sit2') {
                        _this.switchAnimation('eat', 2);
                    }
                }
            }
            _this.frames++;
        });
    };
    //动画播放循环的的回调
    CatInstance.prototype.animationPlayLoop = function () {
        var _this = this;
        this.catSpriteAnimation.on('loop', function () {
            // 可领金币个数
            var receiveCoins = controller_1.default.goldCoinTime;
            var currentResource = _this.catSpriteAnimation.resource;
            if (currentResource === 'reset') {
                _this.resetTimes++;
                if (_this.resetTimes >= 2) {
                    _this.resetTimes = 0;
                    _this.switchAnimation('taste', Infinity);
                }
            }
            else if (currentResource === 'taste') {
                _this.resetTimes++;
                if (_this.resetTimes >= 2) {
                    _this.resetTimes = 0;
                    _this.switchAnimation('back_up', 1);
                }
            }
            else if (currentResource === 'sit2') {
                _this.switchAnimation('eat', 2);
            }
            else if (currentResource === 'stand') {
                if (_this.signPlayHello) {
                    _this.switchAnimation('hello', 1, function () {
                        _this.switchAnimation('loop', Infinity);
                    });
                    _this.signPlayHello = false;
                }
                else {
                    _this.switchAnimation('loop', Infinity);
                }
            }
            else if (currentResource === 'loop') {
                //播放完微笑动画，然后判断是否需要招手
                if (_this.signPlayHello) {
                    _this.switchAnimation('hello', 1, function () {
                        _this.switchAnimation('loop', Infinity);
                    });
                    _this.signPlayHello = false;
                    return;
                }
                //有可领金币
                if (receiveCoins > 0) {
                    _this.switchAnimation('stand', 1);
                }
            }
        });
    };
    //动画播放完成的回调 stop 的时候不会触发
    CatInstance.prototype.animationComplete = function () {
        var _this = this;
        this.catSpriteAnimation.on('complete', function () { return __awaiter(_this, void 0, void 0, function () {
            var currentResource;
            return __generator(this, function (_a) {
                this.endAnimation && this.endAnimation(this.action);
                this.callBackEndAnimation && this.callBackEndAnimation(this.catSpriteAnimation.resource);
                currentResource = this.catSpriteAnimation.resource;
                if (currentResource === 'walk') {
                    this.switchAnimation('sit2', Infinity);
                }
                else if (currentResource === 'eat') {
                    fish_1.Fish.fishHide(); //主动鱼消失
                    // 吃小鱼干完成的回调
                    this.catEatCallBack && this.catEatCallBack('eat');
                    if (controller_1.default && controller_1.default.goldCoinTime <= 0) {
                        this.switchAnimation('taste', Infinity);
                        return [2 /*return*/];
                    }
                    this.endAnimation && this.endAnimation('eat');
                    this.switchAnimation('reset', Infinity);
                }
                else if (currentResource === 'sit2') {
                    this.switchAnimation('eat', 2);
                }
                else if (currentResource === 'turn_back') {
                    this.switchAnimation('stand', Infinity);
                }
                return [2 /*return*/];
            });
        }); });
    };
    // 动画切换
    CatInstance.prototype.switchAnimation = function (currentAction, times, callBack) {
        if (times === void 0) { times = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var currentResource, currentTime, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        currentResource = this.catSpriteAnimation.resource;
                        //忽略掉不切换的情况
                        if (this.ignoreAction.includes(currentResource) && currentAction === 'eat') {
                            return [2 /*return*/];
                        }
                        //tod
                        this.catSpriteAnimation.stop();
                        this.endAnimation = callBack;
                        this.action = currentAction;
                        this.frames = 0;
                        //当前的播放动作
                        if (!this.action)
                            return [2 /*return*/];
                        currentTime = (times === Infinity) ? 1 : times;
                        _a = this;
                        _b = currentTime;
                        return [4 /*yield*/, eva_js_1.resource.getResource(this.action)];
                    case 1:
                        _a.totalFrames = _b * (_c.sent()).instance.length - (this.action === 'back' ? 4 : 2);
                        this.switchGame(this.action);
                        this.catSpriteAnimation.play(times);
                        // RenderAni.renderGame(action);
                        this.playIndex++;
                        return [2 /*return*/];
                }
            });
        });
    };
    /// 监听帧率
    CatInstance.prototype.frameListener = function () {
        var _a = this.catSpriteAnimation, currentFrame = _a.currentFrame, totalFrames = _a.totalFrames, resource = _a.resource;
        console.log(currentFrame, totalFrames, 12312);
        if (!this.backActions.includes(resource)) {
            return;
        }
        var changeAction = "";
        if (currentFrame === totalFrames - 1) {
            if (resource === 'back_up') {
                changeAction = 'back_wallk';
            }
            else if (resource === 'back_wallk') {
                changeAction = 'turn_back';
            }
            else if (resource === "turn_back") {
                changeAction = 'stand';
            }
            this.switchAnimation(changeAction, changeAction === 'stand' ? 1 : Infinity);
        }
    };
    CatInstance.prototype.goBack = function () {
        this.switchGame('back_wallk');
    };
    CatInstance.prototype.remove = function () {
        this.cat.removeComponent(plugin_renderer_sprite_animation_1.SpriteAnimation);
        this.cat.removeComponent(plugin_renderer_event_1.Event);
        this.first = false;
    };
    //添加子对象
    CatInstance.prototype.addChild = function (game) {
        this.cat.addChild(game);
    };
    return CatInstance;
}());
var Cat = new CatInstance();
exports.default = Cat;
